export default __webpack_public_path__ + "static/media/M07.c16287aa.png";